import { render, staticRenderFns } from "./CopyrightRegistryList.vue?vue&type=template&id=69587398&scoped=true&"
import script from "./CopyrightRegistryList.vue?vue&type=script&lang=js&"
export * from "./CopyrightRegistryList.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightRegistryList.vue?vue&type=style&index=0&id=69587398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69587398",
  null
  
)

export default component.exports